'use client'

import { JSX, type PropsWithChildren, useEffect, useState } from 'react'

export function NoSSSR({ children }: PropsWithChildren): JSX.Element | null {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  return <>{children}</>
}

export default NoSSSR
